import React, { FC } from "react";

interface HeaderType {
    imagePath: string;
    imageText: string;
}

const HeaderImage: FC<HeaderType> = ({ imagePath, imageText }) => {
    const styles = {
        backgroundImage: `url(${imagePath})`,
        backgroundSize: "cover",
        width: "100vw",
        height: "65vh",
    };
    return (
        <div style={styles} className="grid place-items-center mt-1  md:mt-20 mb-10">
            <h1 className="max-w-6xl mx-auto m-0 w-4/5 text-center text-white header-text ">{imageText}</h1>
        </div>
    );
};

export default HeaderImage;
